<template lang="html">
 	<div class="downloadList-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.download')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.downloadTasks')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="body-container">
      <div class="table-container verifone-panel">
        <div class="detail-main">

          <el-row :gutter="10">
            <!-- 任务名称 -->
            <el-col :span="10">
              <span class="label-font">{{$t('message.name')}}:&nbsp;&nbsp;</span>
              <span>{{taskName}}</span>
            </el-col>

            <!-- 任务类型 -->
            <el-col :span="7">
              <span class="label-font">{{$t('message.type')}}:&nbsp;&nbsp;</span>
              <span v-if="type == 0" size="small">{{ $t('message.appDownload') }}</span>
              <span v-if="type == 1" size="small">{{ $t('message.appParam') }}</span>
              <span v-if="type == 2" size="small">{{ $t('message.terminalParam') }}</span>
              <span v-if="type == 3" size="small">{{ $t('message.appDelete') }}</span>
              <span v-if="type == 4" size="small">{{ $t('message.appResourceFile') }}</span>
            </el-col>

            <!-- 任务总终端数 -->
            <el-col :span="7">
              <span class="label-font">{{$t('message.totalTerminals')}}:&nbsp;&nbsp;</span>
              <span>{{downloadTotal}}</span>
            </el-col>
          </el-row>

          <div style="margin-top: 10px">
            <el-row :gutter="10">
              <!-- 下载时间 && 删除时间 -->
              <el-col :span="10">
                <span v-if="type != 3" class="downloadLabel label-font">{{$t('message.downloadTime')}}:&nbsp;&nbsp;</span>
                <span v-else class="downloadLabel label-font">{{$t('message.deleteTime')}}:&nbsp;&nbsp;</span>

                <span v-if="downloadType == 0">{{$t('message.nextContact')}}</span>
                <span  v-if="downloadType == 1">
                  <span v-if="downloadDate != null">{{downloadDate}}&nbsp;&nbsp;</span>
                   <span>{{downloadTime}}</span>
                </span>
              </el-col>

              <!-- 任务ID -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.taskId')}}:&nbsp;&nbsp;</span>
                <span>{{taskId}}</span>
              </el-col>

              <!-- 任务创建人 -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.creator')}}:&nbsp;&nbsp;</span>
                <span>{{taskCreator}}</span>
              </el-col>

            </el-row>
          </div>

          <div style="margin-top: 10px">
            <!-- App下载 -->
            <el-row gutter="10" v-if="type == 0">
              <!-- 安装时间 -->
              <div v-if="type == 0">
                <el-col :span="10">
                  <span class="downloadLabel label-font">{{$t('message.installTime')}}:&nbsp;&nbsp;</span>
                  <span v-if="installType == 0">{{$t('message.installImmediately')}}</span>
                  <span v-if="installType == 1">
                   <span v-if="downloadDate != null">{{installDate}}&nbsp;&nbsp;</span>
                    <span>{{installTime}}</span>
                </span>
                </el-col>
              </div>

              <!-- 安装提醒 -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.installNotify')}}:&nbsp;&nbsp;</span>
                <span v-if="remindType == 0">{{$t('message.silentInstall')}}</span>
                <span v-if="remindType == 1">{{$t('message.askCashier')}}</span>
              </el-col>

              <!-- 任务创建时间 -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.createTime')}}:&nbsp;&nbsp;</span>
                <span>{{taskCreateTime}}</span>
              </el-col>
            </el-row>

            <!-- App参数下载 || 终端参数下载 || App资源文件下载 -->
            <el-row gutter="10" v-if="type == 1 || type == 2 || type == 4">
              <!-- 任务创建时间 -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.createTime')}}:&nbsp;&nbsp;</span>
                <span>{{taskCreateTime}}</span>
              </el-col>
            </el-row>

            <!-- App删除任务 -->
            <el-row gutter="10" v-if="type == 3">
              <!-- 是否强制卸载 -->
              <el-col :span="10">
                <span class="downloadLabel label-font">{{$t('message.forceUninstall')}}:&nbsp;&nbsp;</span>
                <span v-if="forceUninstall == 0">{{$t('message.no')}}</span>
                <span v-else-if="forceUninstall == 1">{{$t('message.yes')}}</span>
              </el-col>

              <!-- 删除提醒 -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.DeleteWarning')}}:&nbsp;&nbsp;</span>
                <span v-if="remindType == 0">{{$t('message.SilentUninstall')}}</span>
                <span v-if="remindType == 1">{{$t('message.askOperator')}}</span>
              </el-col>

              <!-- 任务创建时间 -->
              <el-col :span="7">
                <span class="label-font">{{$t('message.createTime')}}:&nbsp;&nbsp;</span>
                <span>{{taskCreateTime}}</span>
              </el-col>
            </el-row>
          </div>

          <div style="margin: 10px auto 20px">
            <el-row :gutter="10" v-if="type == 0 || type == 3">
              <!-- 发布范围 -->
              <el-col :span="24">
                <span class="label-font">{{$t('message.pushRange')}}:&nbsp;&nbsp;</span>
                <span>{{releaseRange}}</span>
              </el-col>
            </el-row>
          </div>

          <!-- App列表 -->
          <span>{{$t('message.appLists')}} ({{appListDownload.length}})</span>
          <el-table :data="appListDownload" :max-height="400" :show-header="false">
            <el-table-column width="50" property="date" label="日期">
              <template slot-scope="scope">
                <img class="app-icon" :src="scope.row.logo" alt="">
              </template>
            </el-table-column>
            <el-table-column property="name" label=""></el-table-column>
            <el-table-column v-if="type != 3" property="version" label=""></el-table-column>
            <el-table-column property="size" label=""></el-table-column>
          </el-table>
          <br>

          <!-- 终端信息列表 -->
          <span>{{$t('message.terminalList')}} ({{terminalList.length}})</span>
          <el-table :data="terminalList" :max-height="400">

            <!-- SN -->
            <el-table-column property="sn" min-width="130" :label="$t('message.sn')" />

            <!-- 设备ID -->
            <el-table-column prop="deviceId" min-width="120" :label="$t('message.deviceId')" />

            <!-- 商户 -->
            <el-table-column prop="merchantName" min-width="250" :label="$t('message.merchant')" />

            <!-- 任务状态 -->
            <el-table-column property="status" min-width="100" :label="$t('message.status')">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0 && scope.row.deliverStatus == 0">
                  {{$t('message.notStart')}}
                </span>
                <span v-if="scope.row.status == 0 && scope.row.deliverStatus == 1">
                  {{$t('message.downloading')}}
                </span>
                <span v-if="scope.row.status == 1">{{$t('message.downSuccess')}}</span>
                <span v-if="scope.row.status == 2">{{$t('message.downFail')}}</span>
                <span v-if="scope.row.status == 3">{{$t('message.installSuccess')}}</span>
                <span v-if="scope.row.status == 4">{{$t('message.installFail')}}</span>
                <span v-if="scope.row.status == 5">{{$t('message.delSuccess')}}</span>
                <span v-if="scope.row.status == 6">{{$t('message.delFail')}}</span>
              </template>
            </el-table-column>

            <!-- 任务下载完成时间 -->
            <el-table-column prop="taskDownloadTime" min-width="150" :label="$t('message.downloadTime')" />

          </el-table>
        </div>

        <div class="submit-container">
          <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.back')}}</el-button>
        </div>
      </div>
    </div>
 	</div>
</template>

<script>
export default {
	data() {
		return {
      taskId:'',
      taskCreator:'',
      taskCreateTime:'',
      releaseRange: '',
      terminalSN: '',
      appParameterTime: '',
      downloadTotal: '',
      downloadType: '1',
      downloadDate: '',
      downloadTime: '',
      installType: '',
      remindType: 0,
      // appListParam: [],
      appListDownload: [],
			terminalList: [],
      type:'', //任务类型
      taskName:'', //任务名称
      forceUninstall:''
		}
	},
  mounted() {
      this.init();
  },
	methods: {
    init() {
      let type = this.$route.params.type,
          id = this.$route.params.id;
      this.queryTaskDetail(type, id);
    },

    callBack() {
      this.$router.replace('/downloadList');
    },

    queryTaskDetail(type, id) {
      let that = this,
        obj = {
            id: id,
            taskType: type
        };
      that.type = type;
      this.$axios({
        method: 'post',
        url: '/marketplace/task/detail',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
        data: obj
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.$message({
            type: "error",
            message: response.data.desc,
            duration:'3000',
          });
          return;
        }else {
          that.appListDownload = response.data.appList ? response.data.appList : [];
          that.downloadTotal = response.data.terminalNum;
          that.remindType = response.data.remindType;
          that.downloadType = response.data.downloadType;
          that.installType = response.data.installType;
          that.releaseRange = response.data.releaseRange;
          that.taskId = response.data.taskId;
          that.taskCreator = response.data.taskCreator;
          that.taskCreateTime = response.data.taskCreateTime;
          that.taskName = response.data.taskName;
          that.forceUninstall = response.data.forceUninstall;

          if(that.downloadType == 1) {
              that.downloadDate = response.data.downloadDate;
              that.downloadTime = response.data.downloadTime;
          }

          if(that.installType == 1) {
            that.installDate = response.data.installDate;
            that.installTime = response.data.installTime;
          }

          that.terminalList = response.data.terminalList ? response.data.terminalList : [];
        }
      }).catch((err) => {
        console.log(err);
      });
    }
	}

}
</script>

<style lang="css" scoped="scoped">
.table-container {
	background-color: #fff;
	position: relative;
}

.app-icon {
	width: 30px;
	height: 30px;
}

.el-table th, .el-table tr {
    height: 51px!important;
}
.terminalSN-dialog .dialog-body {
    text-align: center;
    padding: 0;
}
.terminalSN-dialog .dialog-body span {
    text-align: left;
    padding-left: 20%;
}
.verifone-panel {
    margin-top: 12px;
}

.label-font {
  font-weight: bolder;
}
.detail-main {
  font-size: 12px;
	margin: 20px 50px 20px 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/task/DownloadDetail.vue